const CARGOS = (state, cargos) => {
    state.cargos = cargos;
};


const TIPOCARGO = (state, tipocargo) => {
    state.tipocargo = tipocargo;
};

export default {
    CARGOS,
    TIPOCARGO,
};